import { AppAPIName } from 'src/constants';
import { buildApiEndpointUrl } from 'src/utils/AmplifyApiUtils';

/**
 * Sends an audit event using fetch with keepalive: true so the request
 * completes even after page unload. Used for sessionEnded events fired
 * from beforeunload where RTK Query mutations are unreliable.
 */
export function sendAuditEventOnUnload(
  token: string,
  portalId: string,
  eventType: string,
  eventDescription: string,
  context: Record<string, unknown>,
): void {
  const url = buildApiEndpointUrl(AppAPIName, '/events');

  void fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Portal: portalId,
    },
    body: JSON.stringify({ eventType, eventDescription, context }),
    keepalive: true,
  });
}
